import React, { memo, useState, useMemo, useEffect, useRef } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {actions} from "../../models/stores/actions";
import  * as TYPES  from '../../models/types';
import BannerCarousel from '../BannerCarousel';
import DrawerTabs from '../DrawerTabs';
import CustomProcessSteps from '../CustomProcessSteps';
import { isMath, getModelClientRect } from '../../utils';


import styles from './styles.module.scss';


import close from '../../assets/img/public/close.svg';
import closem from '../../assets/img/public/closem.svg';
import share from '../../assets/img/public/icons/share.svg';



const Index = memo((props) => {

  const dispatch = useDispatch();
  const {basicDrawerEvent, basicDrawerClose, basicOtherModelrClose} = actions;

  const recReSizeReducer = useSelector(({recReSizeReducer}) => recReSizeReducer.value);
  const basicDrawerReducer = useSelector(({basicDrawerReducer}) => basicDrawerReducer);
  const { scrolVal, scrolFidx } = useSelector(({scrollNumReducer}) => scrollNumReducer);

  const [paddingTopVal, setPaddingTopVal] = useState(0);

  // 样式判断
  const normal = useMemo(() => {
    if(recReSizeReducer > 1920){
      setPaddingTopVal(0);
      return styles.normalXl2;
    }

    if(recReSizeReducer > 1440 && recReSizeReducer <= 1920){
      setPaddingTopVal(0);
      return styles.normalXl;
    }

    if(recReSizeReducer > 1024 && recReSizeReducer <= 1440){
      setPaddingTopVal(0);
      return styles.normalLg;
    }

    if(recReSizeReducer > 750 && recReSizeReducer <= 1024){
      setPaddingTopVal(0);
      return styles.normalMd;
    }

    if(recReSizeReducer <= 750){
      setPaddingTopVal(200);
      return styles.normalSm;
    }
  }, [recReSizeReducer]);


  const transitionFed = 'all 1.8s';
  const opacityStart = 0;
  const opacityEnd = 1;
  const translateYStart = `translateY(${isMath(recReSizeReducer, 300)})`;
  const translateYEnd = `translateY(${isMath(recReSizeReducer, 0)})`;

  const translateXStart = `translateX(${isMath(recReSizeReducer, 1500)})`;
  const translateXEnd = `translateX(${isMath(recReSizeReducer, 0)})`;
  const translateYOtherEnd = `translateY(${isMath(recReSizeReducer, 50)})`;

  // 背景透明度 start
  const initFedOpacityStart = {
    opacity: opacityStart,
    transition: transitionFed,
  };
  // 背景透明度 end


  // 位移加透明度 start
  const initFedStart = {
    opacity: opacityStart,
    transition: transitionFed,
    transform: translateYStart,
  };

  const initFedOtherStart = {
    opacity: transitionFed,
    transition: transitionFed,
    transform: translateXStart,
  };
  // 位移加透明度 end

  // TODO: BannerCarousel start
  const bannerCarouselAnimatedTitleContentRef = useRef(null);
  const bannerCarouselAnimatedDescContentRef = useRef(null);

  const bannerCarouselAnimatedESAllILSVRef = useRef(null);
  const bannerCarouselAnimatedESSubRef = useRef(null);

  const [bannerCarouselAnimatedTitleContentStyle, setBannerCarouselAnimatedTitleContentStyleApi] = useState(initFedOtherStart);
  const [bannerCarouselAnimatedDescContentStyle, setBannerCarouselAnimatedDescContentStyleApi] = useState(initFedStart);

  const [bannerCarouselAnimatedESAllILSVStyle, setBannerCarouselAnimatedESAllILSVStyleApi] = useState(initFedStart);
  const [bannerCarouselAnimatedESSubStyle, setBannerCarouselAnimatedESSubtyleApi] = useState(initFedStart);
  // bannerCarouselView
  const bannerCarouselAnimatedTitleContentScroll = (visible) => {
      if (!visible) {
        setBannerCarouselAnimatedTitleContentStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateXStart,
        });
      }else{
        setBannerCarouselAnimatedTitleContentStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateXEnd,
        });
      }
  }

  const bannerCarouselAnimatedDescContentScroll = (visible) => {
      if (!visible) {
        setBannerCarouselAnimatedDescContentStyleApi({
          opacity: opacityStart,
          transition: transitionFed,
          transform: translateXStart,
        });
      }else{
        setBannerCarouselAnimatedDescContentStyleApi({
          opacity: opacityEnd,
          transition: transitionFed,
          transform: translateXEnd,
        });
      }
  }

  // 对桌面和移动端进行判断
  const bannerCarouselAnimatedESAllILSVScroll = (curEle, visible, type) => {
      if(type === 'desktop'){
        if (!visible) {
          setBannerCarouselAnimatedESAllILSVStyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
        }else{
          setBannerCarouselAnimatedESAllILSVStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
        }
      }else{
        if(curEle.current){
          let { isClientRect } = getModelClientRect(curEle, 130); // 当前元素 90
          if (isClientRect) {
            setBannerCarouselAnimatedESAllILSVStyleApi({
              opacity: opacityStart,
              transition: transitionFed,
              transform: translateYStart,
            });
            
          }else{
            setBannerCarouselAnimatedESAllILSVStyleApi({
              opacity: opacityEnd,
              transition: transitionFed,
              transform: translateYEnd,
            });
          }
        }else{
          setBannerCarouselAnimatedESAllILSVStyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
        }
        
      }
      
  }
 

  const bannerCarouselAnimatedESSubScroll = (curEle) => {
      try{
        let { isClientRect } = getModelClientRect(curEle, 200); // 当前元素
        if (isClientRect) {
          setBannerCarouselAnimatedESSubtyleApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setBannerCarouselAnimatedESSubtyleApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
      }catch(e){
        return false;
      }
  }

  const bannerCarouselAnimateScroll = (visible) => {
      if(recReSizeReducer > 750){
          // PC
          bannerCarouselAnimatedTitleContentScroll(visible);
          bannerCarouselAnimatedDescContentScroll(visible);
      }else{
          // H5
          bannerCarouselAnimatedTitleContentScroll(visible);
          bannerCarouselAnimatedDescContentScroll(visible);
      }
  }
  // TODO: BannerCarousel end
  
  // TODO: DrawerTabs start
  const drawerTabsNavsAnimatedRef = useRef(null); // 导航
  const drawerTabsNewTravelItineraryAnimatedRef = useRef(null); // 行程方案
  const drawerTabsPricingAnimatedRef = useRef(null); // 价格内容
  const drawerTabsCustomizationProcessAnimatedRef = useRef(null); // 定制流程
  const drawerTabsFaqAnimatedRef = useRef(null); // 常见问题
  const drawerTabsBookingInstructionsAnimatedRef = useRef(null); // 预定说明

  const [drawerTabsNavsAnimatedStyle, setDrawerTabsNavsAnimatedApi] = useState(initFedStart); // 导航
  const [drawerTabsNewTravelItineraryAnimatedStyle, setDrawerTabsNewTravelItineraryAnimatedApi] = useState(initFedStart); // 行程方案
  const [drawerTabsPricingAnimatedStyle, setDrawerTabsPricingAnimatedApi] = useState(initFedStart); // 价格内容
  const [drawerTabsCustomizationProcessAnimatedStyle, setDrawerTabsCustomizationProcessAnimatedApi] = useState(initFedStart); // 定制流程
  const [drawerTabsFaqAnimatedStyle, setDrawerTabsFaqAnimatedApi] = useState(initFedStart); // 常见问题
  const [drawerTabsBookingInstructionsAnimatedStyle, setDrawerTabsBookingInstructionsAnimatedApi] = useState(initFedStart); // 预定说明
  

  // 导航
  const drawerTabsNavsAnimatedScroll = (curEle) => {
      try{
        let { isClientRect } = getModelClientRect(curEle, 200); // 当前元素
        if (isClientRect) {
          setDrawerTabsNavsAnimatedApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setDrawerTabsNavsAnimatedApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
      }catch(e){
        return false;
      }
  }

  // 行程方案
  const drawerTabsNewTravelItineraryAnimatedScroll = (curEle) => {
      try{
        let { isClientRect } = getModelClientRect(curEle, 500); // 当前元素
        if (isClientRect) {
          setDrawerTabsNewTravelItineraryAnimatedApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setDrawerTabsNewTravelItineraryAnimatedApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
      }catch(e){
        return false;
      }
  }

  // 价格内容
  const drawerTabsPricingAnimatedScroll = (curEle) => {
      try{
        let { isClientRect } = getModelClientRect(curEle, 200); // 当前元素
        if (isClientRect) {
          setDrawerTabsPricingAnimatedApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setDrawerTabsPricingAnimatedApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
      }catch(e){
        return false;
      }
  }

  // 定制流程
  const drawerTabsCustomizationProcessAnimatedScroll = (curEle) => {
      try{
        let { isClientRect } = getModelClientRect(curEle, 770); // 当前元素
        if (isClientRect) {
          setDrawerTabsCustomizationProcessAnimatedApi({
            opacity: opacityStart,
            transition: transitionFed,
            transform: translateYStart,
          });
          
        }else{
          setDrawerTabsCustomizationProcessAnimatedApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
          
        }
      }catch(e){
        return false;
      }
  }

  // 常见问题
  const drawerTabsFaqAnimatedScroll = (curEle) => {
      try{
        const { options } = basicDrawerReducer;
        if(options.type === TYPES.FAQ){
          setDrawerTabsFaqAnimatedApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
        }else{
          const num = recReSizeReducer > 750 ? 200 : 1700;
          let { isClientRect } = getModelClientRect(curEle, num); // 当前元素
          if (isClientRect) {
            setDrawerTabsFaqAnimatedApi({
              opacity: opacityStart,
              transition: transitionFed,
              transform: translateYStart,
            });
          }else{
            setDrawerTabsFaqAnimatedApi({
              opacity: opacityEnd,
              transition: transitionFed,
              transform: translateYEnd,
            });
          }
        }

        
      }catch(e){
        return false;
      }
  }

  // 预定说明
  const drawerTabsBookingInstructionsAnimatedScroll = (curEle) => {
      try{
        const { options } = basicDrawerReducer;
        if(options.type === TYPES.BOOKINGINSTRUCTIONS){
          setDrawerTabsBookingInstructionsAnimatedApi({
            opacity: opacityEnd,
            transition: transitionFed,
            transform: translateYEnd,
          });
        }else{
          const num = recReSizeReducer > 750 ? 200 : 2900;
          let { isClientRect } = getModelClientRect(curEle, num); // 当前元素
          if (isClientRect) {
            setDrawerTabsBookingInstructionsAnimatedApi({
              opacity: opacityStart,
              transition: transitionFed,
              transform: translateYStart,
            });
            
          }else{
            setDrawerTabsBookingInstructionsAnimatedApi({
              opacity: opacityEnd,
              transition: transitionFed,
              transform: translateYEnd,
            });
          }
        }
      }catch(e){
        return false;
      }
  }
  
  // TODO: DrawerTabs end

  useEffect(() => {
    const { visible } = basicDrawerReducer;
    bannerCarouselAnimateScroll(visible)
    if(recReSizeReducer > 750){
      handleInnerCrollMethodsAll(visible, 'desktop');
    }else{
        // H5
        handleInnerCrollMethodsAll(visible, 'mobile');
    }
  }, [basicDrawerReducer.visible]);


  // inner scroll methods
  const handleInnerCrollMethodsAll = (visible, type) => {
      bannerCarouselAnimatedESAllILSVScroll(bannerCarouselAnimatedESAllILSVRef, visible, type);
  }

  const handleInnerCrollMethodsOtherAll = () => {
    bannerCarouselAnimatedESSubScroll(bannerCarouselAnimatedESSubRef);

    drawerTabsNavsAnimatedScroll(drawerTabsNavsAnimatedRef); // 导航
    drawerTabsNewTravelItineraryAnimatedScroll(drawerTabsNewTravelItineraryAnimatedRef); // 行程方案
    drawerTabsPricingAnimatedScroll(drawerTabsPricingAnimatedRef); // 价格内容
    drawerTabsCustomizationProcessAnimatedScroll(drawerTabsCustomizationProcessAnimatedRef); // 定制流程
    drawerTabsFaqAnimatedScroll(drawerTabsFaqAnimatedRef); // 常见问题
    drawerTabsBookingInstructionsAnimatedScroll(drawerTabsBookingInstructionsAnimatedRef); // 预定说明
  }


  useEffect(() => {
    const { options } = basicDrawerReducer;
    if(options.type === TYPES.FAQ){
      drawerTabsFaqAnimatedScroll(drawerTabsFaqAnimatedRef); // 常见问题
    }
    if(options.type === TYPES.BOOKINGINSTRUCTIONS){
      drawerTabsBookingInstructionsAnimatedScroll(drawerTabsBookingInstructionsAnimatedRef); // 常见问题
    }
    // visible: true
  }, [basicDrawerReducer]);

  const handleInitrdrawerTabsState = () => {
    setDrawerTabsFaqAnimatedApi({
      opacity: opacityStart,
      transition: transitionFed,
      transform: translateYStart,
    });

    setDrawerTabsBookingInstructionsAnimatedApi({
      opacity: opacityStart,
      transition: transitionFed,
      transform: translateYStart,
    });
  }



  // 滚动事件
  const handleScrollDrawerBody = () => {
        const { visible } = basicDrawerReducer;
        if(recReSizeReducer > 750){
           handleInnerCrollMethodsOtherAll();
           return false;
        }else{
            // H5
            handleInnerCrollMethodsAll(visible, 'mobile');
            handleInnerCrollMethodsOtherAll();
        }
  }

  const onClose = () => {
    dispatch(basicDrawerEvent({
      visible: TYPES.DRAWERCLOSE,
    }));
    dispatch(basicOtherModelrClose());
    
    handleInitrdrawerTabsState();
  };

  const onOtherClose = () => {
    dispatch(basicDrawerEvent({
      visible: TYPES.DRAWERCLOSE,
    }));
    dispatch(basicOtherModelrClose());
    dispatch(basicDrawerClose());
    handleInitrdrawerTabsState();
  };

  const isBanner = () => {
    if(basicDrawerReducer.options.doTour){
      const { options:{doTour} } = basicDrawerReducer;
      return doTour === TYPES.TRAVELMALL;
    }
  }


  // 对选择 选择想去的目的地 进行判断展示
  const otherShowMain = () => {
    const { options:{type, status}} = basicDrawerReducer;

    if(type){
      switch(type){
        case TYPES.domesticTitle:
          return (
            <CustomProcessSteps 
              config={basicDrawerReducer} 
              handleClone={onClose}
            />
          );
        case TYPES.overseasTitle:
          return (
            <CustomProcessSteps 
              config={basicDrawerReducer} 
              handleClone={onClose}
            />
          );
        case TYPES.contactTitle:
          return (
            <CustomProcessSteps 
              config={basicDrawerReducer} 
              handleClone={onClose}
            />
          );
        case TYPES.customTravel:
          return (
            <CustomProcessSteps 
              config={basicDrawerReducer} 
              handleClone={onClose}
            />
          );
        default:
          return (
            <>
              {
                isBanner() ? (
                  <BannerCarousel
                     config={{
                        getRefs: {
                          innerTitleContentRef: bannerCarouselAnimatedTitleContentRef,
                          innerDescContentRef: bannerCarouselAnimatedDescContentRef,
                          innerESAllILSVRef: bannerCarouselAnimatedESAllILSVRef,
                          innerESSubRef: bannerCarouselAnimatedESSubRef,

                          innerTitleContentStyles: bannerCarouselAnimatedTitleContentStyle,
                          innerDescContentStyles: bannerCarouselAnimatedDescContentStyle,
                          innerESAllILSVStyles: bannerCarouselAnimatedESAllILSVStyle,
                          innerESSubStyles: bannerCarouselAnimatedESSubStyle,
                        },
                     }}
                  />
                ) : null
              }
              <DrawerTabs
                handleClone={onClose}
                config={{
                  getRefs: {
                    innerNavsRef: drawerTabsNavsAnimatedRef, // 导航
                    innerNewTravelItineraryRef: drawerTabsNewTravelItineraryAnimatedRef,  // 行程方案
                    innerPricingRef: drawerTabsPricingAnimatedRef, // 价格内容
                    innerCustomizationProcessRef: drawerTabsCustomizationProcessAnimatedRef,  // 定制流程
                    innerFaqRef: drawerTabsFaqAnimatedRef,// 常见问题
                    innerBookingInstructionsRef: drawerTabsBookingInstructionsAnimatedRef,  // 预定说明

                    innerNavsStyle: drawerTabsNavsAnimatedStyle,   // 导航
                    innerNewTravelItineraryStyle: drawerTabsNewTravelItineraryAnimatedStyle,  // 行程方案
                    innerPricingStyle: drawerTabsPricingAnimatedStyle,  // 价格内容
                    innerCustomizationProcessStyle: drawerTabsCustomizationProcessAnimatedStyle, // 定制流程
                    innerFaqStyle: drawerTabsFaqAnimatedStyle,  // 常见问题
                    innerBookingInstructionsStyle: drawerTabsBookingInstructionsAnimatedStyle,  // 预定说明
                  },
                }}
              />
            </>
          )
      }
    }
    
  }

  

  const isDrawerHeader = (headerCss) => {
    const { options } = basicDrawerReducer;
    const flag = recReSizeReducer <= 750;
    if(options.doTour){
      return (
        <div className="drawerHeader" style={{ ...headerCss, zIndex: 3}}>
          <div onClick={onOtherClose} className="close"><img src={flag ? closem : close} alt=""/></div>
          {/* <div onClick={handleShare} className="share"><img src={share} alt="" /></div> */}
        </div>
      )
    }else if(options.type === TYPES.BOOKINGINSTRUCTIONS || options.type === TYPES.FAQ){
      return (
        <div className="drawerHeader" style={{ ...headerCss, zIndex: 3}}>
          <div onClick={onOtherClose} className="close"><img src={flag ? closem : close} alt=""/></div>
          {/* <div onClick={handleShare} className="share"><img src={share} alt="" /></div> */}
        </div>
      )
    }else{
      return (
        <div className="drawerHeader" style={{ ...headerCss, zIndex: 3}}>
          <div onClick={onOtherClose} className="close"><img src={flag ? closem : close} alt=""/></div>
        </div>
      )
    }

  }

  // 分享
  const handleShare = () => {

    window.navigator.navigator.share({
      title: document.title,
      text: 'Hello World',
      url: 'https://xxxx.xxxx.xxx',
    }); // share web URL
  }

  const modelBody = () => {
    return (
      <>
          {recReSizeReducer <= 750 ? <div className="rectangleTop" /> : null}
          { isDrawerHeader(props.config.styles) }
          <div className="drawerBody" style={props.config.styles} onScroll={handleScrollDrawerBody}>
            {otherShowMain()}
          </div>
      </>
    );
  }

  // 判断是：桌面/移动端
  const desktopMobile = () => {

    const drawerCss = {
      position: 'fixed',
      top: 0,
      zIndex: 1000,
      background: `rgba(0, 0, 0, 0.5)`,
      width: '100vw',
      height: '100vh',
      paddingTop: isMath(recReSizeReducer, paddingTopVal),
    }

    const { visible } = basicDrawerReducer;
   
    return visible ? (
        <div className={normal} style={drawerCss}>
          { modelBody() }
        </div>
    ) : null;
  };


  return desktopMobile();
});
export default Index;
